 
/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};
 
 
 
timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {
    // Select a valid variant if available
    if (variant.available) {
      
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to cart");
      $quantityElements.show();
      $('.btn-sec').html('Buy now');
      
      $('.btn-sec.fgwvd').html('<span class="ima"><img loading="lazy" src="//abstraxtech.com/cdn/shop/t/294/assets/buy-now-button.svg?v=107510227292718901441787075252" width=" " height=" " alt=""></span> Buy now');
      $('a.btn.btnquickbuy').html('<span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="29.901" height="23.846" viewBox="0 0 29.901 23.846"> <defs>  <clipPath id="clip-path"> <rect id="Rectangle_2906" data-name="Rectangle 2906" width="29.901" height="23.846" fill="#1c1c1e"/></clipPath></defs> <g id="Group_5320" data-name="Group 5320" clip-path="url(#clip-path)"> <path id="Path_12514" data-name="Path 12514" d="M7.238,7.1v3.953L20.224,23.845,29.9,13.779,17.332,1.238H8.017l-.779.806V4.99a6.866,6.866,0,0,0,1.6-.661,1.836,1.836,0,1,1,.813,1.842,8.777,8.777,0,0,1-2.411.93M3.791,6.8A4,4,0,0,1,.306,4.628,3.186,3.186,0,0,1,.44,1.636C1.286.4,3.748-.851,7.07.772a.5.5,0,0,1-.442.906C3.88.336,1.92,1.257,1.273,2.2a2.2,2.2,0,0,0-.05,2A3.017,3.017,0,0,0,3.9,5.8a11.221,11.221,0,0,0,6.453-1.672.5.5,0,1,1,.554.842,12.491,12.491,0,0,1-6.18,1.883A8.572,8.572,0,0,1,3.791,6.8" transform="translate(0 0)" fill="#1c1c1e"/> </g></svg></span>Buy now');
       $('a.btn.btnquickbuy').removeClass('disabled');
       $('a.btn.btn-primary.trigg').html('<span class="ima"><img src="//abstraxtech.com/cdn/shop/t/294/assets/cart-icon.svg?v=180411773575337971841787075267" alt=""></span>Add to cart');
       $('a.btn.btn-primary.trigg').removeClass('disabled');
         $('.sticky_cart_right a.btn.btn-primary.add_to_cart_buttona').html('Add to cart');
       $('.sticky_cart_right a.btn.btn-primary.add_to_cart_buttona').removeClass('disabled');
      
      $('.btn-sec').removeClass('disabled');
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold out");
      $('.btn-sec').addClass('disabled');
      $('.btn-sec').html('Sold out');
        $('a.btn.btnquickbuy').html('Sold out');
       $('a.btn.btnquickbuy').addClass('disabled');
       $('a.btn.btn-primary.trigg').html('Sold out');
       $('a.btn.btn-primary.trigg').addClass('disabled');
      $('.sticky_cart_right a.btn.btn-primary.add_to_cart_buttona').html('Sold out');
       $('.sticky_cart_right a.btn.btn-primary.add_to_cart_buttona').addClass('disabled');
      $quantityElements.hide();
    }

// Regardless of stock, update the product price
$productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
var b_b = parseInt(variant.price / 100);

/* if over 1000 it use to change now change if next is over 1e2 = 100*/

if (100 > b_b) {
  $('.pro-price-c ').addClass('B_price');
}
else {
  $('.pro-price-c ').removeClass('B_price');
}
$('.pro-price-c ').html("<s>" + Shopify.formatMoney(inv_qty[variant.id], moneyFormat) + "</s>" + Shopify.formatMoney(variant.price, moneyFormat))

  
 // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Translation missing: en.products.product.compare_at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

jQuery(function() {
  jQuery('.swatch :radio').change(function() {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  });
});
 